import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(VTextField,_vm._b({attrs:{"required":_vm.required,"max":_vm.MAX_NUM_STR,"name":"force-autocomplete-off","data-1p-ignore":"","autocomplete":"off","maxlength":_vm.maxlength,"value":_vm.localStrVal,"type":_vm.inputType,"rules":_vm.computedRules},on:{"blur":_vm.onBlur,"input":_vm.onInput,"keypress":_vm.onKeyPress}},'v-text-field',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }